(function () {
  var DEFAULT_ENDPOINT = "https://api.deepdivesupplements.com/track/";

  var STATUS_MAP = {
    NotFound: {
      label: "Not Found",
      icon: "fas fa-question-circle",
      cls: "notfound",
    },
    InfoReceived: {
      label: "Info Received",
      icon: "fas fa-clipboard-check",
      cls: "inforeceived",
    },
    InTransit: {
      label: "In Transit",
      icon: "fas fa-shipping-fast",
      cls: "intransit",
    },
    Expired: { label: "Expired", icon: "fas fa-clock", cls: "expired" },
    AvailableForPickup: {
      label: "Available for Pickup",
      icon: "fas fa-store",
      cls: "availableforpickup",
    },
    OutForDelivery: {
      label: "Out for Delivery",
      icon: "fas fa-truck",
      cls: "outfordelivery",
    },
    DeliveryFailure: {
      label: "Delivery Failed",
      icon: "fas fa-exclamation-triangle",
      cls: "deliveryfailure",
    },
    Delivered: {
      label: "Delivered",
      icon: "fas fa-check-circle",
      cls: "delivered",
    },
    Exception: {
      label: "Exception",
      icon: "fas fa-exclamation-circle",
      cls: "exception",
    },
  };

  var STEPPER_STEPS = ["Ordered", "Processing", "Shipped", "Delivered"];
  var STEPPER_INDEX = {
    NotFound: 0,
    InfoReceived: 1,
    InTransit: 2,
    OutForDelivery: 2,
    AvailableForPickup: 2,
    Exception: 2,
    DeliveryFailure: 2,
    Expired: 2,
    Delivered: 3,
  };

  var US_CITY_COORDS = {
    "new york,ny": [40.7128, -74.006],
    "jamaica,ny": [40.692, -73.806],
    "los angeles,ca": [34.052, -118.243],
    "city of industry,ca": [34.02, -117.96],
    "san francisco,ca": [37.7749, -122.4194],
    "oakland,ca": [37.8044, -122.2712],
    "chicago,il": [41.878, -87.629],
    "bedford park,il": [41.7561, -87.7847],
    "memphis,tn": [35.149, -90.049],
    "nashville,tn": [36.1627, -86.7816],
    "louisville,ky": [38.252, -85.758],
    "atlanta,ga": [33.749, -84.388],
    "miami,fl": [25.7617, -80.1918],
    "orlando,fl": [28.5383, -81.3792],
    "dallas,tx": [32.7767, -96.797],
    "houston,tx": [29.7604, -95.3698],
    "austin,tx": [30.2672, -97.7431],
    "el paso,tx": [31.7619, -106.485],
    "phoenix,az": [33.4484, -112.074],
    "denver,co": [39.7392, -104.9903],
    "seattle,wa": [47.6062, -122.3321],
    "portland,or": [45.5152, -122.6784],
    "salt lake city,ut": [40.7608, -111.891],
    "kansas city,mo": [39.0997, -94.5786],
    "saint louis,mo": [38.627, -90.1994],
    "minneapolis,mn": [44.9778, -93.265],
    "detroit,mi": [42.3314, -83.0458],
    "cleveland,oh": [41.4993, -81.6944],
    "columbus,oh": [39.9612, -82.9988],
    "philadelphia,pa": [39.9526, -75.1652],
    "pittsburgh,pa": [40.4406, -79.9959],
    "boston,ma": [42.3601, -71.0589],
    "newark,nj": [40.7357, -74.1724],
    "anchorage,ak": [61.2181, -149.9003],
    "honolulu,hi": [21.3069, -157.8583],
    "san juan,pr": [18.4655, -66.1057],
    "washington,dc": [38.9072, -77.0369],
    "charlotte,nc": [35.2271, -80.8431],
    "raleigh,nc": [35.7796, -78.6382],
    "indianapolis,in": [39.7684, -86.1581],
  };

  function escHtml(str) {
    var d = document.createElement("div");
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  function stripCJK(s) {
    if (!s) return s;
    return s
      .replace(/[\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F]/g, "")
      .trim();
  }

  function formatDate(isoStr) {
    if (!isoStr) return "";
    var d = new Date(isoStr);
    if (isNaN(d.getTime())) return isoStr;
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var month = months[d.getMonth()];
    var day = d.getDate();
    var year = d.getFullYear();
    var h = d.getHours();
    var m = d.getMinutes();
    var ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    var min = m < 10 ? "0" + m : m;
    return (
      month + " " + day + ", " + year + " at " + h + ":" + min + " " + ampm
    );
  }

  function buildCityKey(addr, locationStr) {
    var city = "";
    var state = "";
    if (addr && addr.city) city = addr.city;
    if (addr && addr.state) state = addr.state;
    if ((!city || !state) && locationStr) {
      var m = String(locationStr).match(/^\s*([A-Za-z .'-]+),\s*([A-Z]{2})\b/);
      if (m) {
        if (!city) city = m[1];
        if (!state) state = m[2];
      }
    }
    if (!city || !state) return null;
    return (
      city.toLowerCase().trim().replace(/\s+/g, " ") +
      "," +
      state.toLowerCase().trim()
    );
  }

  function init(root) {
    if (!root || root.getAttribute("data-dd-init") === "1") return;
    root.setAttribute("data-dd-init", "1");

    var ENDPOINT = root.getAttribute("data-endpoint") || DEFAULT_ENDPOINT;

    var form = root.querySelector("#trackForm");
    var submitBtn = root.querySelector("#trackSubmit");
    if (!form || !submitBtn) return;
    var submitLabel = submitBtn.querySelector(".track-submit__label");
    var numberInput = root.querySelector("#trackNumber");
    var resultsEl = root.querySelector("#trackResults");
    var errorEl = root.querySelector("#trackError");
    var statusCard = root.querySelector("#trackStatusCard");
    var metricsEl = root.querySelector("#trackMetrics");
    var timelineEl = root.querySelector("#trackTimeline");
    var mapInstance = null;

    function hideResults() {
      resultsEl.classList.remove("is-visible");
      errorEl.classList.remove("is-visible");
    }

    function showError(type, title, body) {
      hideResults();
      var iconEl = root.querySelector("#trackErrorIcon");
      var iconI = root.querySelector("#trackErrorIconI");
      var titleEl = root.querySelector("#trackErrorTitle");
      var bodyEl = root.querySelector("#trackErrorBody");
      iconEl.className =
        "track-error-banner__icon track-error-banner__icon--" + type;
      if (type === "warning") {
        iconI.className = "fas fa-search";
      } else if (type === "info") {
        iconI.className = "fas fa-info-circle";
      } else {
        iconI.className = "fas fa-exclamation-circle";
      }
      titleEl.textContent = title;
      bodyEl.textContent = body;
      errorEl.classList.add("is-visible");
      errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    function renderStatus(trackInfo, number) {
      var ls = trackInfo.latest_status || {};
      var status = ls.status || "NotFound";
      var mapped = STATUS_MAP[status] || STATUS_MAP.NotFound;
      var subDescr = stripCJK(ls.sub_status_descr || "");

      var provider = null;
      var providers =
        (trackInfo.tracking && trackInfo.tracking.providers) || [];
      if (providers.length > 0) provider = providers[0].provider || null;

      var carrierName = stripCJK(
        provider ? provider.name || provider.alias || "" : "",
      );

      var html = '<div class="track-status-header">';
      html +=
        '<span class="track-status-badge track-status-badge--' +
        mapped.cls +
        '"><i class="' +
        mapped.icon +
        '"></i> ' +
        mapped.label +
        "</span>";
      if (subDescr)
        html += '<p class="track-status-sub">' + escHtml(subDescr) + "</p>";
      html += "</div>";
      html += '<div class="track-status-meta">';
      html +=
        '<span class="track-status-meta__item"><i class="fas fa-barcode"></i> <strong>' +
        escHtml(number) +
        "</strong></span>";
      if (carrierName)
        html +=
          '<span class="track-status-meta__item"><i class="fas fa-truck"></i> ' +
          escHtml(carrierName) +
          "</span>";
      var le = trackInfo.latest_event || {};
      if (le.time_iso)
        html +=
          '<span class="track-status-meta__item"><i class="fas fa-clock"></i> Last update: ' +
          formatDate(le.time_iso) +
          "</span>";
      html += "</div>";

      statusCard.innerHTML = html;
    }

    function renderMetrics(trackInfo) {
      var tm = trackInfo.time_metrics || {};
      var items = [];
      if (tm.days_of_transit != null && tm.days_of_transit >= 0)
        items.push({ value: tm.days_of_transit, label: "Days in Transit" });
      if (tm.days_of_transit_done != null && tm.days_of_transit_done > 0)
        items.push({
          value: tm.days_of_transit_done,
          label: "Days to Deliver",
        });
      if (
        tm.days_after_last_update != null &&
        tm.days_after_last_update >= 0
      )
        items.push({
          value: tm.days_after_last_update,
          label: "Days Since Update",
        });
      if (tm.estimated_delivery_date && tm.estimated_delivery_date.from) {
        var est = tm.estimated_delivery_date.from;
        if (
          tm.estimated_delivery_date.to &&
          tm.estimated_delivery_date.to !== est
        )
          est += " - " + tm.estimated_delivery_date.to;
        items.push({ value: est, label: "Est. Delivery", isDate: true });
      }
      if (items.length === 0) {
        metricsEl.style.display = "none";
        return;
      }
      metricsEl.style.display = "";
      var html = "";
      for (var i = 0; i < items.length && i < 3; i++) {
        html +=
          '<div class="track-metric"><div class="track-metric__value">' +
          (items[i].isDate
            ? '<span style="font-size:16px;">' +
              escHtml(items[i].value) +
              "</span>"
            : items[i].value) +
          "</div>";
        html +=
          '<div class="track-metric__label">' +
          items[i].label +
          "</div></div>";
      }
      metricsEl.innerHTML = html;
    }

    function renderTimeline(trackInfo) {
      var providers =
        (trackInfo.tracking && trackInfo.tracking.providers) || [];
      var events = [];
      for (var p = 0; p < providers.length; p++) {
        var pe = providers[p].events || [];
        for (var e = 0; e < pe.length; e++) events.push(pe[e]);
      }
      if (events.length === 0) {
        timelineEl.innerHTML =
          '<p style="color:#8a8a93;font-size:14px;margin:0;">No tracking events available yet. Check back later for updates.</p>';
        return;
      }
      events.sort(function (a, b) {
        var ta = a.time_iso || a.time_utc || "";
        var tb = b.time_iso || b.time_utc || "";
        return ta > tb ? -1 : ta < tb ? 1 : 0;
      });

      var isDelivered =
        trackInfo.latest_status &&
        trackInfo.latest_status.status === "Delivered";
      var html = "";
      for (var i = 0; i < events.length; i++) {
        var ev = events[i];
        var desc = stripCJK(
          (ev.description_translation &&
            ev.description_translation.description) ||
            ev.description ||
            "",
        );
        var loc = stripCJK(ev.location || "");
        var time = ev.time_iso || ev.time_utc || "";
        var deliveredClass =
          i === 0 && isDelivered ? " track-timeline__event--delivered" : "";
        html += '<div class="track-timeline__event' + deliveredClass + '">';
        html += '<span class="track-timeline__dot"></span>';
        if (time)
          html +=
            '<div class="track-timeline__time">' +
            formatDate(time) +
            "</div>";
        if (desc)
          html +=
            '<div class="track-timeline__desc">' + escHtml(desc) + "</div>";
        if (loc)
          html +=
            '<div class="track-timeline__loc"><i class="fas fa-map-marker-alt" aria-hidden="true"></i> ' +
            escHtml(loc) +
            "</div>";
        html += "</div>";
      }
      timelineEl.innerHTML = html;
    }

    function renderStepper(status) {
      var stepperEl = root.querySelector("#trackStepper");
      if (!stepperEl) return;
      var activeIdx = STEPPER_INDEX[status];
      if (activeIdx == null) activeIdx = 1;
      var html = '<ol class="track-stepper__list">';
      for (var i = 0; i < STEPPER_STEPS.length; i++) {
        var cls = "";
        if (i < activeIdx) cls = "is-done";
        else if (i === activeIdx) cls = "is-current";
        html +=
          '<li class="track-stepper__step ' +
          cls +
          '"><span class="track-stepper__dot"></span>' +
          '<span class="track-stepper__label">' +
          STEPPER_STEPS[i] +
          "</span></li>";
      }
      html += "</ol>";
      stepperEl.innerHTML = html;
    }

    function renderMap(trackInfo) {
      var card = root.querySelector("#trackMapCard");
      var mapEl = root.querySelector("#trackMap");
      if (!card || !mapEl) return;
      if (typeof L === "undefined") {
        card.style.display = "none";
        return;
      }
      card.style.display = "";

      var providers =
        (trackInfo.tracking && trackInfo.tracking.providers) || [];
      var pts = [];
      for (var p = 0; p < providers.length; p++) {
        var evs = providers[p].events || [];
        for (var i = 0; i < evs.length; i++) {
          var ev = evs[i];
          var lat = null;
          var lng = null;
          var c = ev.address && ev.address.coordinates;
          if (
            c &&
            typeof c.latitude === "number" &&
            typeof c.longitude === "number"
          ) {
            lat = c.latitude;
            lng = c.longitude;
          } else {
            var key = buildCityKey(ev.address, ev.location);
            if (key && US_CITY_COORDS[key]) {
              lat = US_CITY_COORDS[key][0];
              lng = US_CITY_COORDS[key][1];
            }
          }
          if (lat != null && lng != null && lng <= 0 && lat >= 17 && lat <= 72) {
            var labelParts = [];
            if (ev.address && ev.address.city)
              labelParts.push(stripCJK(ev.address.city));
            else if (ev.location) labelParts.push(stripCJK(ev.location));
            if (ev.address && ev.address.state)
              labelParts.push(ev.address.state);
            pts.push({
              lat: lat,
              lng: lng,
              label: labelParts.join(", "),
              time: ev.time_iso || ev.time_utc || "",
            });
          }
        }
      }

      if (mapInstance) {
        mapInstance.remove();
        mapInstance = null;
      }
      var map = L.map(mapEl, {
        zoomControl: true,
        scrollWheelZoom: false,
        dragging: true,
        touchZoom: true,
        maxBounds: [
          [15, -180],
          [72, -60],
        ],
        minZoom: 3,
        maxZoom: 10,
      });
      mapInstance = map;
      L.tileLayer(
        "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
        {
          attribution: "&copy; OpenStreetMap &copy; CARTO",
          subdomains: "abcd",
          maxZoom: 19,
        },
      ).addTo(map);

      if (pts.length === 0) {
        map.fitBounds([
          [24.5, -125],
          [49.5, -66],
        ]);
        setTimeout(function () {
          map.invalidateSize();
        }, 60);
        return;
      }

      var chrono = pts.slice().sort(function (a, b) {
        return (a.time || "") > (b.time || "") ? 1 : -1;
      });
      var latestTime = "";
      for (var t = 0; t < pts.length; t++) {
        if (pts[t].time > latestTime) latestTime = pts[t].time;
      }
      if (chrono.length >= 2) {
        L.polyline(
          chrono.map(function (p) {
            return [p.lat, p.lng];
          }),
          {
            color: "#2B4C6F",
            weight: 2,
            opacity: 0.5,
            dashArray: "5,6",
          },
        ).addTo(map);
      }
      for (var j = 0; j < pts.length; j++) {
        var isLatest = pts[j].time === latestTime;
        var marker = L.circleMarker([pts[j].lat, pts[j].lng], {
          radius: isLatest ? 9 : 6,
          fillColor: "#2B4C6F",
          color: "#fff",
          weight: 2,
          fillOpacity: isLatest ? 1 : 0.7,
        }).addTo(map);
        if (pts[j].label)
          marker.bindPopup("<strong>" + escHtml(pts[j].label) + "</strong>");
      }
      if (pts.length === 1) {
        map.setView([pts[0].lat, pts[0].lng], 6);
      } else {
        map.fitBounds(
          pts.map(function (p) {
            return [p.lat, p.lng];
          }),
          { padding: [40, 40], maxZoom: 8 },
        );
      }
      setTimeout(function () {
        map.invalidateSize();
      }, 60);
    }

    var retryBtn = root.querySelector("#trackErrorBtn");
    if (retryBtn) {
      retryBtn.addEventListener("click", function () {
        hideResults();
        numberInput.focus();
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var number = numberInput.value.trim();
      if (!number) return;

      hideResults();
      submitBtn.classList.add("is-loading");
      submitBtn.disabled = true;
      submitLabel.textContent = "Tracking...";

      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ number: number }),
      })
        .then(function (res) {
          if (!res.ok)
            return res.json().then(function (d) {
              throw new Error(d.error || "Request failed");
            });
          return res.json();
        })
        .then(function (data) {
          submitBtn.classList.remove("is-loading");
          submitBtn.disabled = false;
          submitLabel.textContent = "Track Package";

          if (data.code !== 0) {
            showError(
              "error",
              "Tracking Error",
              data.data && data.data.errors && data.data.errors[0]
                ? data.data.errors[0].message
                : "An unexpected error occurred. Please try again.",
            );
            return;
          }
          if (
            data.data &&
            data.data.rejected &&
            data.data.rejected.length > 0
          ) {
            var rejMsg = data.data.rejected[0].error
              ? data.data.rejected[0].error.message
              : "Tracking number not recognized.";
            showError(
              "warning",
              "Tracking Number Not Found",
              rejMsg +
                " Please double-check your tracking number and try again.",
            );
            return;
          }
          if (
            !data.data ||
            !data.data.accepted ||
            data.data.accepted.length === 0
          ) {
            showError(
              "warning",
              "No Results",
              "We could not find any tracking information for this number. Please check your tracking number and try again.",
            );
            return;
          }

          var item = data.data.accepted[0];
          var trackInfo = item.track_info;
          if (!trackInfo) {
            showError(
              "info",
              "No Tracking Data Yet",
              "Your shipment has been registered but no tracking events are available yet. Please check back later.",
            );
            return;
          }

          renderStepper(
            (trackInfo.latest_status && trackInfo.latest_status.status) || "",
          );
          renderStatus(trackInfo, item.number || number);
          renderMetrics(trackInfo);
          renderMap(trackInfo);
          renderTimeline(trackInfo);
          resultsEl.classList.add("is-visible");
          resultsEl.scrollIntoView({ behavior: "smooth", block: "start" });
        })
        .catch(function (err) {
          submitBtn.classList.remove("is-loading");
          submitBtn.disabled = false;
          submitLabel.textContent = "Track Package";
          showError(
            "error",
            "Something Went Wrong",
            err.message ||
              "Unable to reach the tracking service. Please try again later.",
          );
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll(".dd-track");
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
